import {createActionTypes, createActionCreators} from 'utils/reduxUtils';

const typesArray = [
    'ENABLE_NOTIF_MODAL_MOUNT',
    'ENABLE_NOTIF_MODAL_APPROVE',
    'ENABLE_NOTIF_MODAL_DENY',
];

export const ActionTypes = createActionTypes(typesArray);
export const Actions = createActionCreators(typesArray);
